module.exports = __webpack_public_path__ + "static/media/audi-bg-smoke.4a8879ec.png";